import {NXEnvironmentType} from "platform/protocol/enum/NXEnvironmentType";
import {DepositButtonActionType} from "protocol/sso/DepositButtonActionType";

export class AccountState {

    private static _instance: AccountState;
    private _userId: number;
    private _accountId: number;
    private _accountType: NXEnvironmentType;
    private _depositButtonType: DepositButtonActionType;

    private constructor() {
    }

    public static instance(): AccountState {
        return this._instance || (this._instance = new this());
    }

    public get userId(): number {
        return this._userId;
    }

    public set userId(value: number) {
        this._userId = value;
    }

    public get accountId(): number {
        return this._accountId;
    }

    public set accountId(value: number) {
        this._accountId = value;
    }

    public get accountType(): NXEnvironmentType {
        return this._accountType;
    }

    public set accountType(value: NXEnvironmentType) {
        this._accountType = value;
    }

    public set depositButtonType(value: DepositButtonActionType) {
        this._depositButtonType = value;
    }

    public getDepositButtonType() : DepositButtonActionType {
        return this._depositButtonType;
    }

    public clear(): void {
        this._userId = null;
        this._accountId = null;
        this._accountType = null;
        this._depositButtonType = null;
    }
}
